import { Modal } from 'antd';
import styled from 'styled-components';
import { colorGroup } from '../common';
import { flex } from '../minix';

export const CustomModal = styled(Modal)<{ isShowPadding: boolean; minHeight?: number }>`
	width: 60vw;
	.ant-modal-header {
		border-bottom: 2px solid #f0f0f0;
	}
	.ant-modal-body {
		padding: ${({ isShowPadding }) => (isShowPadding ? '20px' : '0')};
		min-height: ${({ minHeight }) => (minHeight ? minHeight + 'px' : '200px')};
		max-height: 80vh;

		overflow-y: auto;
		.ant-form-item-label > label {
			color: #6c788c;
		}
	}
	.ant-modal-footer {
		height: 55px;
		line-height: 55px;
		border-top: 2px solid rgba(242, 243, 245, 1);
		box-sizing: border-box;
		text-align: center;
		${flex('row', 'flex-end')}

		.ant-btn {
			font-size: 14px;
			padding: 2px 16px;
			height: auto;
			:first-child {
				color: ${colorGroup.primaryColor};
				border: none;
				span {
					:hover {
						text-decoration: underline;
					}
				}
			}

			:last-child {
				background: ${colorGroup.primaryColor};
				/* width: ; */
				height: 32px;
			}
		}
	}
`;
